// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"0bd06c5d","156":"581cf267","241":"9731390f","431":"a39e377c","489":"923c737b","608":"cb4e9e70"}[chunkId] + ".chunk.js";
};